import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactLoading from 'react-loading';
import UploadRecord from './upload-records';
import Invoice from './invoice';
import BookKeeping from "./book-keeping";
import ReceivePayments from "./receive-payment";
import { catchError } from '../../helpers/catch-error'
import { useNavigate } from "react-router-dom";
import InputAuto from '../../helpers/input-auto';
import { formatDate } from '../../helpers/formatted-dates';



const CaseInformation = ({ work_order, onWorkOrderChange, is_loading = true, readOnly = false }) => {
    const navigate = useNavigate();
    const adminRole = parseInt(localStorage.getItem("@admin_role") || "-1", 10);

    const [woMask, setWoMask] = useState(true);
    const [woPartialPatientAuthorization, setWoPartialPatientAuthorization] = useState(null);
    const [woPartialPatientAuthorization2, setWoPartialPatientAuthorization2] = useState(null);
    const [woPartialPatientAuthorization3, setWoPartialPatientAuthorization3] = useState(null);


    const [isBtn, setIsBtn] = useState(false)
    const [inputError, setInputError] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [orderTypes, setOrderTypes] = useState(null);
    const [wo, setWo] = useState(null);

    const [facilityLogData, setFacilityLogData] = useState(null);
const [showFacilityModal, setShowFacilityModal] = useState(false);



    useEffect(() => {

        getOrderTypes();

    }, [])
    useEffect(() => {
        const l = localStorage.getItem('@last_name') + " " + localStorage.getItem('@first_name');
        if (work_order?.work_order_id > 0) {

            let w = work_order;
            if (work_order?.needed_by_date)
                w.needed_by_date = w.needed_by_date_f;
            if (!work_order?.wo_admit_date)
                w.wo_admit_date = "5 Year History";

            if (work_order?.wo_special_instructions == null) {
                w.wo_special_instructions = "All Records System Wide For Time Frame.";
            }

            if (work_order?.wo_request_submitted_by == null || work_order?.wo_request_submitted_by == "") {
                w.wo_request_submitted_by = l;
            }

            if (w?.facility_fee)
                w.facility_fee = parseFloat(w.facility_fee).toFixed(2);

            if (w?.client_fee)
                w.client_fee = parseFloat(w.client_fee).toFixed(2);

            setWo(w);

        }

    }, [work_order?.work_order_id]);




    const getOrderTypes = async (e) => {

        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/get-order-types", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setOrderTypes(response?.data?.order_types);


            } else {

                Swal.fire({ icon: "error", title: "Order Types", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)

        });

    }


    const updatewo = async (e) => {

        setIsBtn(true);
        let error_flag = false;

        const { wo_order_type, client_fee, facility_fee, wo_admit_date, wo_policy_number } = wo;
        if (!wo_order_type || !wo_admit_date
            || (client_fee && client_fee != "" && !client_fee?.toString()?.match(/^[0-9]*\.\d{1,2}$/))
            || (facility_fee && facility_fee != "" && !facility_fee?.toString()?.match(/^[0-9]*\.\d{1,2}$/))) {



            error_flag = true;
        }


        if (error_flag) {

            setInputError(true);
            setIsBtn(false);

        } else {

            if (!wo_policy_number || wo_policy_number == "") {
                Swal.fire({
                    icon: "info",
                    title: "No Policy Number Entered",
                    text: "You haven’t entered a policy number. You can continue, but it’s recommended to include one."
                });

            }
            var wo_info = {
                work_order_id: work_order?.work_order_id,
                wo_order_type: wo?.wo_order_type,
                client_reference_number: wo?.client_reference_number,
                wo_policy_number: wo?.wo_policy_number,
                wo_insured: wo?.wo_insured,
                facility_fee: wo?.facility_fee,
                client_fee: wo?.client_fee,
                needed_by_date: wo?.needed_by_date,
                wo_admit_date: wo?.wo_admit_date,
                wo_case_open: wo?.wo_case_open,
                wo_auth_submit: wo?.wo_auth_submit,
                wo_special_instructions: wo?.wo_special_instructions,
                wo_case_instructions: wo?.wo_case_instructions,
                wo_request_submitted_by: wo?.wo_request_submitted_by,
                wo_partial_patient_authorization: wo?.wo_partial_patient_authorization,
                wo_partial_patient_authorization_2: wo?.wo_partial_patient_authorization_2,
                wo_partial_patient_authorization_3: wo?.wo_partial_patient_authorization_3,
            }



            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-wo", wo_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {


                    setWo(wo_info);
                    setEditMode(false)

                    onWorkOrderChange(wo_info);

                } else {

                    Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {
                setIsBtn(false);
                catchError(error, navigate)
            });

        }


    }



    const toggleWoMask = () => {

        if (woMask) {
            setWoMask(false);
        }
        else {
            setWoMask(true);

        }

    }



    const removeWoPartialPatientAuthorization = async (e) => {

        setIsBtn(true);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/remove-wo-partial-patient-authorization",
            {
                work_order_id: work_order?.work_order_id
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {
                setIsBtn(false);
                if (response?.data?.status) {

                    setWoPartialPatientAuthorization(null);
                    setWo({ ...wo, wo_partial_patient_authorization: null })



                } else {
                    Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });
                    setIsBtn(false)
                }

            }).catch(function (error) {
                setIsBtn(false);
                catchError(error, navigate)
            });



    }




    const autoUpdate = async () => {

        setIsBtn(true);

        let d = new Date();
        let day = d.getDay();
        let incrday = 0;

        if (day <= 2) {
            incrday = 3;
        } else if (day <= 5) {
            incrday = 5;
        } else if (day == 6) {
            incrday = 4;
        }

        d.setDate(d.getDate() + incrday);

        d = formatDate(d);



        var note_info = {
            work_order_id: work_order?.work_order_id,
            note_status: "Request Forward To Facility For Processing On STAT, TT 1 - 2 Weeks",
            follow_up_date: d,
            wo_status: 3,
            case_manager_access: 0,
            note_description: "",
            note_internal_description: "",

        }

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-note", note_info, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: true
        }).then(function (response) {
            setIsBtn(false);
            if (response?.data?.status) {

              
                Swal.fire({ icon: "success", title: "Work Order status Updated", text: response?.data?.message });
                    window.location.reload();

                
            } else {
                Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });
                setIsBtn(false)
            }


        }).catch(function (error) {
            setIsBtn(false);
            catchError(error, navigate)
        });
    }

    const addWoPartialPatientAuthorization = async () => {

        setIsBtn(true);
        let auth = {
            work_order_id: work_order.work_order_id,
            wo_partial_patient_authorization: woPartialPatientAuthorization,
        }

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-wo-partial-patient-authorization", auth, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: true
        }).then(async function (response) {

            if (response?.data?.status) {

                setWo({ ...wo, wo_partial_patient_authorization: response?.data?.wo_partial_patient_authorization })
                setWoPartialPatientAuthorization(null);
                if (work_order?.status < 3) {
                    const result = await Swal.fire({
                        title: "Success",
                        text: "Work Order Patient Authorization has been uploaded successfully. Do you want to auto update?",
                        icon: "success",
                        showCancelButton: true,
                        confirmButtonText: "Yes, auto update",
                        cancelButtonText: "No",
                    });

                    if (result.isConfirmed) {
                        // call your auto update function here
                        await autoUpdate();
                    }
                }

            } else {

                Swal.fire({ icon: "error", title: "WORK ORDER PATIENT AUTHORIZATION FAILED TO UPLOAD", text: "Please ensure that your file is in PDF format and that its size is less than 30MB. Please try again" });

            }
            setIsBtn(false);

        }).catch(function (error) {
            Swal.fire({ icon: "error", title: "WORK ORDER PATIENT AUTHORIZATION FAILED TO UPLOAD", text: "Please ensure that your file is in PDF format and that its size is less than 30MB. Please try again" });
            catchError(error, navigate)
        });


    }






    const removeWoPartialPatientAuthorization2 = async (e) => {

        setIsBtn(true);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/remove-wo-partial-patient-authorization-2",
            {
                work_order_id: work_order?.work_order_id
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {
                setIsBtn(false);
                if (response?.data?.status) {

                    setWoPartialPatientAuthorization2(null);
                    setWo({ ...wo, wo_partial_patient_authorization_2: null })



                } else {
                    Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });
                    setIsBtn(false)
                }

            }).catch(function (error) {
                setIsBtn(false);
                catchError(error, navigate)
            });



    }



    const addWoPartialPatientAuthorization2 = async () => {

        setIsBtn(true);
        let auth = {
            work_order_id: work_order.work_order_id,
            wo_partial_patient_authorization_2: woPartialPatientAuthorization2,
        }

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-wo-partial-patient-authorization-2", auth, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setWo({ ...wo, wo_partial_patient_authorization_2: response?.data?.wo_partial_patient_authorization_2 })
                setWoPartialPatientAuthorization2(null);


            } else {

                Swal.fire({ icon: "error", title: "WORK ORDER PATIENT AUTHORIZATION FAILED TO UPLOAD", text: "Please ensure that your file is in PDF format and that its size is less than 30MB. Please try again" });

            }
            setIsBtn(false);

        }).catch(function (error) {
            Swal.fire({ icon: "error", title: "WORK ORDER PATIENT AUTHORIZATION FAILED TO UPLOAD", text: "Please ensure that your file is in PDF format and that its size is less than 30MB. Please try again" });
            catchError(error, navigate)
        });


    }





    const removeWoPartialPatientAuthorization3 = async (e) => {

        setIsBtn(true);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/remove-wo-partial-patient-authorization-3",
            {
                work_order_id: work_order?.work_order_id
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {
                setIsBtn(false);
                if (response?.data?.status) {

                    setWoPartialPatientAuthorization3(null);
                    setWo({ ...wo, wo_partial_patient_authorization_3: null })



                } else {
                    Swal.fire({ icon: "error", title: "wo Info", text: response?.data?.message });
                    setIsBtn(false)
                }

            }).catch(function (error) {
                setIsBtn(false);
                catchError(error, navigate)
            });



    }



    const addWoPartialPatientAuthorization3 = async () => {

        setIsBtn(true);
        let auth = {
            work_order_id: work_order.work_order_id,
            wo_partial_patient_authorization_3: woPartialPatientAuthorization3,
        }

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-wo-partial-patient-authorization-3", auth, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setWo({ ...wo, wo_partial_patient_authorization_3: response?.data?.wo_partial_patient_authorization_3 })
                setWoPartialPatientAuthorization3(null);


            } else {

                Swal.fire({ icon: "error", title: "WORK ORDER PATIENT AUTHORIZATION FAILED TO UPLOAD", text: "Please ensure that your file is in PDF format and that its size is less than 30MB. Please try again" });

            }
            setIsBtn(false);

        }).catch(function (error) {
            Swal.fire({ icon: "error", title: "WORK ORDER PATIENT AUTHORIZATION FAILED TO UPLOAD", text: "Please ensure that your file is in PDF format and that its size is less than 30MB. Please try again" });
            catchError(error, navigate)
        });


    }

    const formatLabel = (key) => {
    if (!key) return '';
    return key
        .replace(/_/g, ' ')                  // Replace underscores with spaces
        .replace(/([A-Z])/g, ' $1')          // Insert space before capital letters
        .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
};


const showFacilityLogs = () => {
    axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-facility-logs-by-work-order-id/" + work_order.work_order_id, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    }).then(function (response) {
        const logs = response?.data?.logs;

        if (Array.isArray(logs) && logs.length > 0) {
            const log = logs[0];
            let entries = null;

            try {
                const obj = typeof log.facility_info === "string" ? JSON.parse(log.facility_info) : log.facility_info;
                entries = Object.entries(obj || {}).filter(
                    ([, v]) => v !== null && v !== undefined && String(v).trim() !== ""
                );
            } catch (e) {
                entries = null;
            }

            setFacilityLogData({ entries, raw: log.facility_info });
            setShowFacilityModal(true);
        } else {
            setFacilityLogData({ entries: null, raw: "No facility logs found for this work order." });
            setShowFacilityModal(true);
        }
    }).catch(function (error) {
        catchError(error, navigate);
    });
};


    return (
        <>
            <div className="card card-form" >
                <div className="card-body p-0" >

                    <div className=" card-heading row m-0 py-3" >
                        <div className="col-md-5 col-sm-12 ps-3">  <h6 className=" fw-bold text-dark m-0">WORK ORDER INFORMATION

                        </h6></div>
                        {work_order?.status < 7 && !readOnly && adminRole >= 0 &&

                            <div className="col-md-7 col-sm-12 text-md-end text-sm-center  ">

                                {!work_order?.wo_order_type || editMode ?
                                    <>

                                        <button onClick={() => updatewo()} className="btn btn-sm  btn-success me-1 " type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPDATE"}</button>
                                        <button onClick={() => setEditMode(false)} className="btn btn-sm   btn-warning me-1 " type="button">CANCEL UPDATE</button>

                                    </>
                                    :
                                    <>
                                        <button onClick={() => setEditMode(true)} className="btn btn-sm    btn-success me-1 " type="button">EDIT</button>
                                        {adminRole == 1 &&
                                            <button onClick={() => toggleWoMask()} className="btn btn-sm btn-info me-1 " type="button">{woMask ? "UN-MASK" : "MASK"} </button>
                                        }
                                        <a href={"/admin/wo-print/" + work_order.work_order_id} target="_blank" className="btn btn-sm btn-warning me-1 " >PRINT</a>
                                        <a href={"/admin/cnr-print/" + work_order.work_order_id} target="_blank" className="btn btn-sm btn-danger me-1 " >PRINT CNR</a>
                                    </>
                                }








                            </div>
                        }
                    </div>




                    {is_loading ?
                        <div className="text-center m-auto loader" >
                            <ReactLoading type={"cylon"} color={"#54418B"} height={250} width={250} />
                        </div>
                        :

                        <form id="frm_wo" >

                            <div className="row " >

                                <div className="col-xl-12 col-lg-12" >
                                    <div className="" >

                                        {(!work_order?.wo_order_type || editMode) ?

                                            <>
                                                <div className="row px-3 py-3 gx-2 ">

                                                    <div className="col-2 my-2">
                                                        <label htmlFor="wo_order_type" >ORDER TYPE*</label>
                                                        <InputAuto name="wo_order_type" className="form-control" minStart="2"
                                                            value={wo?.wo_order_type}
                                                            pholder=""
                                                            data={orderTypes}
                                                            field="type_name"
                                                            onChange={(e) =>
                                                                setWo({ ...wo, wo_order_type: e })
                                                            }
                                                            onSelected={(e) => {
                                                                setWo({ ...wo, wo_order_type: e.type_name })

                                                            }
                                                            }

                                                        />

                                                        {inputError && !wo?.wo_order_type &&
                                                            <span className="text-danger">Select work order type</span>
                                                        }




                                                    </div>


                                                    <div className="col-2 my-2">
                                                        <label htmlFor="wo_request_submitted_by" >WO Requested By</label>
                                                        <input name="wo_request_submitted_by" className="form-control"
                                                            value={wo?.wo_request_submitted_by}
                                                            onChange={(e) =>
                                                                setWo({ ...wo, wo_request_submitted_by: e.target.value })
                                                            }
                                                        />


                                                    </div>





                                                    <div className="col-2 my-2">
                                                        <label htmlFor="client_reference_number">CLIENT REF#</label>

                                                        <input name="client_reference_number" className="form-control"
                                                            value={wo?.client_reference_number}
                                                            onChange={(e) =>
                                                                setWo({ ...wo, client_reference_number: e.target.value })
                                                            }

                                                        />

                                                    </div>


                                                    <div className="col-2 my-2">
                                                        <label htmlFor="wo_policy_number" >POLICY#</label>
                                                        <input name="wo_policy_number" className="form-control"
                                                            value={wo?.wo_policy_number}
                                                            onChange={(e) =>
                                                                setWo({ ...wo, wo_policy_number: e.target.value })
                                                            }

                                                        />





                                                    </div>






                                                    <div className="col-2 my-2">
                                                        <label htmlFor="wo_insured">PURPOSE/INTENT</label>
                                                        <select name="wo_insured" className=" form-select"
                                                            value={wo?.wo_insured}
                                                            onChange={(e) =>
                                                                setWo({ ...wo, wo_insured: e.target.value })
                                                            }
                                                        >
                                                            <option value="" selected={(!wo?.wo_insured || wo?.wo_insured == "") ? "selected" : ""} ></option>
                                                            <option value="LIFE INSURANCE" selected={(wo?.wo_insured == "LIFE INSURANCE") ? "selected" : ""} >LIFE INSURANCE</option>
                                                            <option value="CLAIMS REVIEW" selected={(wo?.wo_insured == "CLAIMS REVIEW") ? "selected" : ""}>CLAIMS REVIEW</option>
                                                            <option value="THIRD PARTY LIABILITY" selected={(wo?.wo_insured == "THIRD PARTY LIABILITY") ? "selected" : ""}>THIRD PARTY LIABILITY</option>
                                                        </select>

                                                    </div>




                                                    <div className="col-2 my-2">
                                                        <label htmlFor="needed_by_date">CUSTOM DATE</label>

                                                        <DatePicker name="needed_by_date" id="needed_by_date" type="text"
                                                            className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            selected={wo?.needed_by_date}
                                                            onChange={(e) => {
                                                                if (e) {
                                                                    var dt = new Date(e);

                                                                    const year = dt.getFullYear();
                                                                    const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                                                    const day = dt.getDate().toString().padStart(2, "0");

                                                                    const formatted_date = month + '/' + day + '/' + year

                                                                    setWo({ ...wo, needed_by_date: formatted_date })
                                                                }
                                                                else {
                                                                    setWo({ ...wo, needed_by_date: "" })
                                                                }

                                                            }
                                                            }
                                                        />


                                                    </div>

                                                    <div className="col-6 my-2">
                                                        <label htmlFor="wo_admit_date">ADMISSION TIME PERIOD*</label><br />
                                                        <div>

                                                            <div className="form-check-inline">

                                                                <input className="me-1 form-check-input" onClick={(e) => setWo({ ...wo, wo_admit_date: "3 Year History" })} type="radio" name="wo_admit_date" value="3 Year History" checked={wo?.wo_admit_date == "3 Year History" ? true : false} />
                                                                <label className="me-0 form-check-label fw-normal"  >3 Years</label>
                                                            </div>
                                                            <div className="form-check-inline">
                                                                <input className="me-1 form-check-input " onClick={(e) => setWo({ ...wo, wo_admit_date: "5 Year History" })} type="radio" name="wo_admit_date" value="5 Year History" checked={wo?.wo_admit_date == "5 Year History" ? true : false} />
                                                                <label className="me-0 form-check-label fw-normal"  >5 Years</label>
                                                            </div>
                                                            <div className="form-check-inline me-0">
                                                                <input className="me-1 form-check-input" onClick={(e) => setWo({ ...wo, wo_admit_date: "" })} type="radio" name="wo_admit_date" value="Other" checked={(wo?.wo_admit_date != "3 Year History" && wo?.wo_admit_date != "5 Year History") ? true : false} />
                                                                <label className="me-0 form-check-label fw-normal"  >Others(specify)</label>
                                                            </div>

                                                            <input name="wo_admit_date_others" className="form-control d-inline w-120 ms-1"
                                                                value={(wo?.wo_admit_date != "3 Year History" && wo?.wo_admit_date != "5 Year History") ? wo?.wo_admit_date : ""}
                                                                onChange={(e) =>
                                                                    setWo({ ...wo, wo_admit_date: e.target.value })
                                                                }

                                                            />


                                                            {inputError &&
                                                                !wo?.wo_admit_date && (
                                                                    <span className="text-danger">Enter admission time period</span>
                                                                )}
                                                        </div>




                                                    </div>


                                                    {adminRole == 1 && (<>
                                                        <div className="col-2 my-2">
                                                            <label htmlFor="facility_fee">FACILITY FEE (dd.cc)$</label><br />

                                                            <input name="facility_fee" className="form-control"
                                                                value={wo?.facility_fee}
                                                                onChange={(e) =>
                                                                    setWo({ ...wo, facility_fee: e.target.value })
                                                                }

                                                            />
                                                            {inputError &&
                                                                (wo?.facility_fee && !wo?.facility_fee?.toString()?.match(/^[0-9]*\.\d{1,2}$/)) && (
                                                                    <span className="text-danger">Enter facility fee in dd.cc format</span>
                                                                )}


                                                        </div>


                                                        <div className="col-2 my-2">
                                                            <label htmlFor="client_fee">CLIENT FEE (dd.cc)$</label><br />
                                                            <input name="client_fee" className="form-control"
                                                                value={wo?.client_fee}
                                                                onChange={(e) =>
                                                                    setWo({ ...wo, client_fee: e.target.value })
                                                                }

                                                            />

                                                            {inputError &&
                                                                ((wo?.client_fee && !wo?.client_fee?.toString()?.match(/^[0-9]*\.\d{1,2}$/))) && (
                                                                    <span className="text-danger">Enter client fee in dd.cc format.</span>
                                                                )}

                                                            <label htmlFor="total_fee">TOTAL FEE$:<b className="text-danger"> {(wo?.client_fee > 0 && wo?.facility_fee > 0) ? (parseFloat(wo?.client_fee) + parseFloat(wo?.facility_fee)).toFixed(2) : ""}</b>

                                                            </label>

                                                        </div>
                                                    </>)}

                                                    <div className="col-6 my-2">

                                                        <div className="mt-3">
                                                            <div className="form-check-inline">

                                                                <label htmlFor="wo_case_open">HOW CASE SUBMITTED: </label>


                                                                <div className="form-check-inline">
                                                                    <input className="me-1 form-check-input" onClick={(e) => setWo({ ...wo, wo_case_open: "Online" })} type="radio" name="wo_case_open" value="Online" checked={wo?.wo_case_open == "Online" ? true : false} />
                                                                    <label className="me-0 form-check-label fw-normal"  >Online</label>
                                                                </div>

                                                                <div className="form-check-inline">
                                                                    <input className="me-1 form-check-input" onClick={(e) => setWo({ ...wo, wo_case_open: "Data Entry" })} type="radio" name="wo_case_open" value="Data Entry" checked={(wo?.wo_case_open == "Data Entry") ? true : false} />

                                                                    <label className="me-0 form-check-label fw-normal"  >Data Entry</label>
                                                                </div>

                                                            </div>

                                                        </div>

                                                    </div>










                                                    {!editMode &&
                                                        <div className="col-3 my-2">

                                                            <div className="mt-2">
                                                                <div className="form-check-inline">


                                                                    <label htmlFor="wo_auth_submit">PATIENT AUTHORIZATION FORM: </label>

                                                                    <div className="form-check-inline">
                                                                        <input className="me-1 form-check-input" onClick={(e) => setWo({ ...wo, wo_auth_submit: "Fax" })} type="radio" name="wo_auth_submit" value="Fax" checked={wo?.wo_auth_submit == "Fax" ? true : false} />
                                                                        <label className="me-0 form-check-label fw-normal"  >Fax</label>
                                                                    </div>

                                                                    <div className="form-check-inline">
                                                                        <input className="me-1 form-check-input" onClick={(e) => setWo({ ...wo, wo_auth_submit: "Email" })} type="radio" name="wo_auth_submit" value="Email" checked={(wo?.wo_auth_submit == "Email") ? true : false} />
                                                                        <label className="me-0 form-check-label fw-normal"  >Email</label>
                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>
                                                    }
                                                </div>
                                                <div className="row px-3 py-3 gx-2 ">

                                                    <div className="col-xl-6 col-lg-6 col-sm-12 my-2">
                                                        <label htmlFor="wo_special_instructions">SPECIAL INSTRUCTIONS</label>
                                                        <textarea rows="2" name="wo_special_instructions" id="wo_special_instructions"
                                                            className="form-control"
                                                            onChange={(e) => {
                                                                setWo({ ...wo, wo_special_instructions: e.target.value })
                                                            }}
                                                            value={wo?.wo_special_instructions}

                                                        >

                                                            {wo?.wo_special_instructions}
                                                        </textarea>
                                                        (Special Instructions will be seen by everyone with access to this record)

                                                    </div>


                                                    <div className="col-xl-6 col-lg-6 col-sm-12 my-2">
                                                        <label htmlFor="wo_case_instructions">CASE INSTRUCTIONS</label>
                                                        <textarea rows="2" name="wo_case_instructions" id="wo_case_instructions"
                                                            className="form-control"
                                                            onChange={(e) => {
                                                                setWo({ ...wo, wo_case_instructions: e.target.value })
                                                            }}
                                                            value={wo?.wo_case_instructions}

                                                        >

                                                            {wo?.wo_case_instructions}
                                                        </textarea>

                                                    </div>

                                                </div>

                                            </>
                                            :
                                            <>
                                                <div className="row px-3 gx-2 py-3">

                                                    <div className="col-2 my-2">
                                                        <label htmlFor="wo_order_type" >ORDER TYPE</label><br />
                                                        <label className="field-info" >{work_order?.wo_order_type}</label>



                                                    </div>
                                                    <div className="col-2 my-2">
                                                        <label htmlFor="wo_request_submitted_by" >WO Requested By</label><br />
                                                        <label className="field-info tt-none" >{work_order?.wo_request_submitted_by}</label>



                                                    </div>




                                                    <div className="col-2 my-2">
                                                        <label htmlFor="client_reference_number">CLIENT REF#</label><br />

                                                        <label className="field-info tt-none" >{work_order?.client_reference_number ? work_order?.client_reference_number : ""}</label>


                                                    </div>


                                                    <div className="col-2 my-2">
                                                        <label htmlFor="wo_policy_number" >POLICY#</label><br />
                                                        <label className="field-info tt-none" >{work_order?.wo_policy_number ? work_order?.wo_policy_number : ""}</label>



                                                    </div>









                                                    <div className="col-2 my-2">
                                                        <label htmlFor="wo_insured">PURPOSE/INTENT</label><br />
                                                        <label className="field-info" >{work_order?.wo_insured ? work_order?.wo_insured : ""}</label>



                                                    </div>


                                                    <div className="col-2 my-2">
                                                        <label htmlFor="needed_by_date">CUSTOM DATE</label><br />
                                                        <label className="field-info" >{work_order?.needed_by_date ? work_order?.needed_by_date : ""}</label>



                                                    </div>

                                                    <div className="col-2  my-2">
                                                        <label htmlFor="wo_admit_date">ADMISSION TIME PERIOD</label><br />
                                                        <label className="field-info" >{work_order?.wo_admit_date ? work_order?.wo_admit_date : ""}</label>

                                                    </div>


                                                    {work_order?.wo_auth_submit &&
                                                        <div className="col-2 my-2" >

                                                            <label htmlFor="patient_authorization" >HOW AUTHORIZATION SUBMITTED: {work_order.wo_auth_submit}</label>


                                                        </div>
                                                    }


                                                    <div className="col-2 my-2">
                                                        <label htmlFor="facility_fee">FACILITY FEE: $</label><br />


                                                        {woMask ?
                                                            <label className="field-info">*****</label>
                                                            :
                                                            <label className="field-info" >{work_order?.facility_fee ? parseFloat(work_order?.facility_fee).toFixed(2) : ""}</label>

                                                        }



                                                    </div>


                                                    <div className="col-2 my-2">
                                                        <label htmlFor="client_fee">CLIENT FEE: $</label><br />
                                                        {woMask ?
                                                            <label className="field-info">*****</label>
                                                            :
                                                            <label className="field-info" >{work_order?.client_fee ? parseFloat(work_order?.client_fee).toFixed(2) : ""}</label>

                                                        }

                                                    </div>

                                                    <div className="col-2 my-2">
                                                        <label htmlFor="total_fee">TOTAL FEE: $</label><br />

                                                        {woMask ?
                                                            <label className="field-info">*****</label>
                                                            :
                                                            <label className="field-info text-danger" >{(work_order?.client_fee > 0 && work_order?.facility_fee > 0) ? (parseFloat(work_order?.client_fee) + parseFloat(work_order?.facility_fee)) : ""}</label>

                                                        }


                                                    </div>

                                                    <div className="col-4 my-2">
                                                        <label htmlFor="wo_case_open">HOW CASE SUBMITTED:</label>
                                                        <label className="field-info" >{work_order?.wo_case_open ? work_order?.wo_case_open : ""}</label>



                                                    </div>







                                                    <div className="col-6 my-2">
                                                        <label htmlFor="wo_special_instructions">SPECIAL INSTRUCTIONS: </label>
                                                        <label className="field-info tt-none" >{work_order?.wo_special_instructions ? work_order?.wo_special_instructions : ""}</label>


                                                    </div>

                                                    <div className="col-6 my-2">
                                                        <label htmlFor="wo_case_instructions">CASE INSTRUCTIONS: </label>
                                                        <label className="field-info tt-none" >{work_order?.wo_case_instructions ? work_order?.wo_case_instructions : ""}</label>


                                                    </div>

                                                </div>

                                            </>
                                        }


                                        {adminRole >= 0 &&
                                            <>
                                             

                                             <div className="row pb-3 px-3 gx-2">
    <div className="col-12">
        <hr />
        <div className="d-flex justify-content-between align-items-center mt-2">
            <label htmlFor="wo_partial_patient_authorization" className="mb-0">
                WORK ORDER PATIENT AUTHORIZATION: 
                {!wo?.wo_partial_patient_authorization && (
                    <span className="text-success fw-bold ms-2">
                        SAME AS PATIENT AUTHORIZATION
                    </span>
                )}
            </label>

            {work_order?.status <= 4 && !readOnly && adminRole >= 0 && (
                <button 
                    type="button"
                    onClick={showFacilityLogs} 
                    className="btn btn-sm btn-link text-primary p-0 fw-bold text-decoration-none"
                >
                    Facility Logs 
                </button>
            )}
        </div>
    </div>
</div>

                                                <div className="row pb-3 px-3 gx-2">


                                                    <div className="col-md-4 col-sm-12 ">


                                                        {(work_order && work_order?.work_order_id > 0) &&

                                                            <>

                                                                {wo?.wo_partial_patient_authorization ?
                                                                    <>
                                                                        <label className="field-info mt-2">YES</label>
                                                                        <div className="">
                                                                            <a className="btn btn-sm btn-sm btn-success ms-1" href={process.env.REACT_APP_WEB_SERVICES_URL + "/admin/download-wo-partial-patient-authorization/" + work_order.work_order_id} target="_blank" >Download</a>
                                                                            {work_order?.status < 7 && !readOnly &&
                                                                                <a className="btn btn-sm btn-sm btn-warning ms-1" href="javascript:void(0)" onClick={removeWoPartialPatientAuthorization} disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "DELETE"}</a>
                                                                            }
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {work_order?.status < 7 && !readOnly &&
                                                                            <div className="input-group w-auto ms-3 ">
                                                                                <input name="wo_partial_patient_authorization" id="wo_partial_patient_authorization" type="file" className="form-control"
                                                                                    accept="application/pdf" onChange={(e) =>
                                                                                        setWoPartialPatientAuthorization(e.target.files[0])}

                                                                                />
                                                                                <a className="btn btn-sm  btn-success ms-1" href="javascript:void(0)" onClick={(e) =>
                                                                                    addWoPartialPatientAuthorization()} disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPLOAD"}</a>

                                                                            </div>
                                                                        }
                                                                    </>
                                                                }
                                                            </>
                                                        }
                                                    </div>


                                                    <div className="col-md-4 col-sm-12 ">


                                                        {(work_order && work_order?.work_order_id > 0) &&

                                                            <>

                                                                {wo?.wo_partial_patient_authorization_2 ?
                                                                    <>
                                                                        <label className="field-info mt-2">YES</label>
                                                                        <div className="">
                                                                            <a className="btn btn-sm btn-sm btn-success ms-1" href={process.env.REACT_APP_WEB_SERVICES_URL + "/admin/download-wo-partial-patient-authorization-2/" + work_order.work_order_id} target="_blank" >Download</a>
                                                                            {work_order?.status < 7 && !readOnly && <a className="btn btn-sm btn-sm btn-warning ms-1" href="javascript:void(0)" onClick={removeWoPartialPatientAuthorization2} disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "DELETE"}</a>}

                                                                        </div>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {work_order?.status < 7 && !readOnly &&
                                                                            <div className="input-group w-auto ms-3 ">
                                                                                <input name="wo_partial_patient_authorization_2" id="wo_partial_patient_authorization_2" type="file" className="form-control"
                                                                                    accept="application/pdf" onChange={(e) =>
                                                                                        setWoPartialPatientAuthorization2(e.target.files[0])}

                                                                                />
                                                                                <a className="btn btn-sm  btn-success ms-1" href="javascript:void(0)" onClick={(e) =>
                                                                                    addWoPartialPatientAuthorization2()} disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPLOAD"}</a>
                                                                            </div>
                                                                        }
                                                                    </>
                                                                }
                                                            </>
                                                        }
                                                    </div>



                                                    <div className="col-md-4 col-sm-12">


                                                        {(work_order && work_order?.work_order_id > 0) &&

                                                            <>

                                                                {wo?.wo_partial_patient_authorization_3 ?
                                                                    <>
                                                                        <label className="field-info mt-2">YES</label>
                                                                        <div className="">
                                                                            <a className="btn btn-sm btn-sm btn-success ms-1" href={process.env.REACT_APP_WEB_SERVICES_URL + "/admin/download-wo-partial-patient-authorization-3/" + work_order.work_order_id} target="_blank" >Download</a>
                                                                            {work_order?.status < 7 && !readOnly && <a className="btn btn-sm btn-sm btn-warning ms-1" href="javascript:void(0)" onClick={removeWoPartialPatientAuthorization3} disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "DELETE"}</a>}

                                                                        </div>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {work_order?.status < 7 && !readOnly &&
                                                                            <div className="input-group w-auto ms-3 ">
                                                                                <input name="wo_partial_patient_authorization_3" id="wo_partial_patient_authorization_3" type="file" className="form-control"
                                                                                    accept="application/pdf" onChange={(e) =>
                                                                                        setWoPartialPatientAuthorization3(e.target.files[0])}

                                                                                />
                                                                                <a className="btn btn-sm  btn-success ms-1" href="javascript:void(0)" onClick={(e) =>
                                                                                    addWoPartialPatientAuthorization3()} disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPLOAD"}</a>
                                                                            </div>
                                                                        }
                                                                    </>
                                                                }
                                                            </>
                                                        }
                                                    </div>


                                                </div>



                                                {work_order.status >= 1 && work_order.authorization_status == 1 && adminRole >= 0 &&
                                                    <>
                                                        <UploadRecord work_order={work_order} onWorkOrderChange={(e) => { onWorkOrderChange(e); }} readOnly={readOnly} />

                                                        {work_order.status >= 4 &&
                                                            <Invoice work_order={work_order} onWorkOrderChange={(e) => { onWorkOrderChange(e); }} readOnly={readOnly} />
                                                        }
                                                        <BookKeeping work_order={work_order} onWorkOrderChange={(e) => { onWorkOrderChange(e); }} readOnly={readOnly} />


                                                        <ReceivePayments work_order={work_order} onWorkOrderChange={(e) => { onWorkOrderChange(e); }} readOnly={readOnly} />
                                                    </>
                                                }

                                            </>
                                        }

                                    </div>
                                </div>






                            </div>

                        </form>


                    }
                </div>



            </div>




{showFacilityModal && (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title fs-6 fw-bold">Facility Information Provided By Case Manager</h5>
                    <button 
                        type="button" 
                        className="btn-close" 
                        onClick={() => setShowFacilityModal(false)}
                    ></button>
                </div>
                <div className="modal-body" style={{ maxHeight: '400px', overflowY: 'auto', textAlign: 'left' }}>
                    {facilityLogData?.entries && facilityLogData.entries.length > 0 ? (
                        facilityLogData.entries.map(([k, v]) => {
                            const label = typeof formatLabel === 'function' ? formatLabel(k) : k;
                            return (
                                <p key={k} style={{ margin: '6px 0' }}>
                                    <strong>{label}:</strong> {String(v)}
                                </p>
                            );
                        })
                    ) : (
                        <p>{facilityLogData?.raw || 'No details available'}</p>
                    )}
                </div>
                <div className="modal-footer">
                    <button 
                        type="button" 
                        className="btn btn-secondary btn-sm" 
                        onClick={() => setShowFacilityModal(false)}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
)}




        </>

    );
};

export default CaseInformation;